import { httpGet, httpPost, httpDelete, httpInstance } from "./core";

const get = async <T>(url: string): Promise<undefined | T> => {
  const reqUrl = url.toLowerCase().startsWith("http")
    ? url
    : `${process.env.REACT_APP_WSP_API_BASE_URL}${url}`;

  return httpGet(reqUrl);
};

const post = async <T>(
  url: string,
  data?: any,
  headers?: any,
): Promise<undefined | T> => {
  return httpPost(`${process.env.REACT_APP_WSP_API_BASE_URL}${url}`, {
    data,
    headers,
  });
};

const put = async <T>(
  url: string,
  data?: any,
  headers?: any,
): Promise<undefined | T> => {
  try {
    const response = await httpInstance.put(
      `${process.env.REACT_APP_WSP_API_BASE_URL}${url}`,
      data,
      { headers },
    );
    return response.data;
  } catch (error) {
    console.error("HTTP PUT error:", error);
    return undefined;
  }
};

const deleteUrl = async <T>(url: string): Promise<undefined | T> => {
  return httpDelete(`${process.env.REACT_APP_WSP_API_BASE_URL}${url}`);
};

export { get, post, put, deleteUrl as delete };
